// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"06a9b2e7","977":"2d954fc6"}[chunkId] + ".chunk.js";
};